import { takeEvery, call, put, select } from 'redux-saga/effects';
import { t } from 'utils/translates';
import {
  sendRequest,
  requestInProcess,
  requestFinished,
  setErrors,
  selectFormBody,
  clearAllErrors,
  initState
} from '../sendFeedbackForm';
import { timeoutCall } from '../../../../../../../utils/sagaHalper';
import FeedbackService from '../../../../../services/FeedbackService';
import * as clientNoticesActions from '../../../../../../main/reducers/static/states/clientNotices/reducer';

function* sendFeedbackSaga(reducerName) {
  const formBody = yield select(selectFormBody, reducerName);
  yield put(requestInProcess(reducerName));
  try {
    yield put(clearAllErrors(reducerName));

    const result = yield call(
      timeoutCall,
      FeedbackService.createFeedback,
      formBody
    );
    if (result) {
      if (result.status === 422) {
        yield put(setErrors(reducerName, result.data));
      } else if (result.status === 201) {
        yield put(initState(reducerName));
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'success',
            message: t('Ваше обращение успешно отправлено')
          })
        );
      }
    }
    yield put(
      requestFinished(reducerName, result.status, result.status === 201)
    );
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
  yield put(requestFinished(reducerName));
}

export default function getSaga(reducerName) {
  return [
    takeEvery(sendRequest(reducerName).type, sendFeedbackSaga, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/feedback/reducers/static/forms/sendFeedback/sagas/sendFeedbackSaga.js